import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styles from './Verification.module.css';
import { firebase } from "../../firebase";

const Verification = ({ history }) => {

    const [code, setCode] = useState('')

    const phone = localStorage.getItem('phone')

    const setUpReCaptcha = () => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('reCaptcha-verifier', {
          'size': 'invisible',
          'callback': (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            onSignInSubmit();
          }
        });  
      }
      
    const onSignInSubmit = () => {
          const phoneNumber = `+92 ${phone}`;
          const appVerifier = window.recaptchaVerifier
          setUpReCaptcha()
          
          firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
          .then((confirmationResult) => {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            window.confirmationResult = confirmationResult;
            // ...
          }).catch((error) => {
            // Error; SMS not sent
            // ...
            console.log(error)
          });
      
        }
      

    const handleOTP = () => {
        window.confirmationResult.confirm(code).then((result) => {
            // User signed in successfully.
            const user = result.user;
            // ...
            console.log('user ====>', user)
            history.push('/')
        }).catch((error) => {
            // User couldn't sign in (bad verification code?)
            // ...
            console.log('error ====>', error)
          });      
    }
    
    return (
        <div className={styles.container}>
            <header>
                <h2>Enter 6 digit verification code sent on your given number</h2>
                <div className={styles.status}>
                    <p>verify number by code</p>
                    <p onClick={onSignInSubmit}><strong>Send</strong></p>
                </div>
            </header>

            <main>
                <div className={styles.field}>
                    <label>Enter OTP</label>
                    <input value={code} onChange={e => setCode(e.target.value)} type="text" name="otp" placeholder="Enter 6 digit verification code" />
                </div>
                <button onClick={handleOTP}>Submit</button>
                <div id='reCaptcha-verifier'></div>
                {/* <Link to="/"><button>Submit</button></Link> */}
            </main>
        </div>
    )
}

export default Verification
